const amenities = [
  { icon: 'ri-drop-line', label: 'Kopalnica s tušem', desc: 'Zasebna kopalnica v vsaki sobi' },
  { icon: 'ri-tv-2-line', label: 'TV', desc: 'Za sproščeno večerno druženje' },
  { icon: 'ri-wifi-line', label: 'Brezžični internet', desc: 'Brezplačen WiFi po celotnem objektu' },
  { icon: 'ri-hand-heart-line', label: 'Brisače', desc: 'Sveže brisače, pripravljene za goste' },
  { icon: 'ri-hotel-line', label: 'Posteljnina', desc: 'Čista in udobna posteljnina' },
];

export default function RoomsAmenities() {
  return (
    <section id="oprema" className="relative bg-background-50 py-16 md:py-24 lg:py-28">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-3">
              OPREMA SOB
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950 mb-4">
              Vse, kar potrebuješ za počitek
            </h2>
            <p className="font-body text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
              Vsaka soba je opremljena z osnovno opremo za sproščeno in prijetno bivanje.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {amenities.map((item) => (
              <div
                key={item.label}
                className="amenity-item group flex items-start gap-4 bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 transition-all duration-300 hover:border-accent-300/60"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/12 flex-shrink-0 transition-colors duration-300 group-hover:bg-accent-500/20">
                  <i className={`${item.icon} text-accent-600 text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-lg text-foreground-950 mb-1">{item.label}</h3>
                  <p className="font-body text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}